import { Feature } from "util/stdtypes";
import { AdminConfig } from "structure/admin";
import { Pad } from "component/basics";
import { RestrictedScreen } from "component/admin";
import { PadBox } from "component/basics";
import { CTAButton } from "component/button";
import { useState } from "react";
import { Heading, TextField } from "component/text";

export const ErrorTestFeature : Feature<AdminConfig, {}> = {
    name: 'Error Test',
    key: 'error-test',
    subscreens: {
        errorTest: ErrorTestScreen,
    },
    config: {
        quickLinks: [
            {label: '!Error Test', screenKey: 'errorTest'},
        ]
    }
}

function ErrorTestScreen() {
    const [message, setMessage] = useState('');
    return <RestrictedScreen capability='admin/error-test' pad>
        <PadBox horiz={20} bottom={20}>
            <Pad />
            <Heading type="large" weight="medium" label='!Error Test' />
            <Pad />
            <TextField multiline={false}value={message} onChangeText={setMessage} 
                placeholder='!Enter a fake error message' 
            />
            <Pad />
            <CTAButton text='Test Error' onPress={() => {
                console.log('Button clicked with message: ' + message);
                throw new Error('Test Error: ' + message);
            }} />
        </PadBox>
    </RestrictedScreen>
}

